import { valueTokens } from "../../designTokens";
import type { Theme } from "../types/theme";

export const darkTheme: Theme = {
  // Typography
  "--text-primary": valueTokens.$beige100,
  "--text-secondary": valueTokens["$white65%"],
  "--text-black": valueTokens.$gray300,
  "--text-white": valueTokens.$beige100,
  "--text-inverted": valueTokens.$gray200,
  "--text-logo": valueTokens.$dGreen500,

  // Background
  "--background-primary": valueTokens.$black,
  "--background-secondary": valueTokens.$gray400,
  "--background-tertiary": valueTokens.$gray200,
  "--background-inverted": valueTokens.$beige100,
  "--background-white": valueTokens.$white,
  "--surface-neutral": valueTokens["$white8%"],

  // Border and dividers
  "--border-distinct": valueTokens.$gray100,
  "--border-subtle": valueTokens.$gray200,
  "--border-subtle-non-darkmode": "transparent",
  "--border-input": valueTokens.$beige500,

  // Buttons & Links
  "--button-primary": valueTokens.$dGreen300,
  "--button-border": valueTokens["$white65%"],
  "--button-dismissive": valueTokens.$dRed400,
  "--link-primary": valueTokens.$dGreen300,

  // Status
  "--active-highlight": valueTokens.$dGreen300,
  "--notification": valueTokens.$dAmber400,
  "--surface-success": valueTokens.$dGreen150,
  "--on-surface-success": valueTokens.$dGreen500,
  "--surface-highlight": valueTokens.$dAmber200,
  "--on-surface-highlight": valueTokens.$dAmber500,
  "--surface-info": valueTokens.$dIndigo200,
  "--on-surface-info": valueTokens.$dIndigo500,
  "--surface-error-light": valueTokens.$dRed500,
  "--surface-shared": valueTokens.$dBrown100,
  "--on-surface-shared": valueTokens.$dAmber500,
  "--error-text": valueTokens.$dRed300,
  "--on-surface-error-light": valueTokens.$beige100,

  // Disabled
  "--surface-disabled": valueTokens.$gray200,
  "--on-surface-disabled": valueTokens["$white50%"],
  "--border-disabled": valueTokens.$gray100,

  // States
  "--hover-background": valueTokens["$white8%"],
  "--button-primary-hover": valueTokens.$dGreen250,
  "--button-dismissive-hover": valueTokens.$dRed500,
  "--button-filled-hover": valueTokens.$gray100,
  "--link-primary-hover": valueTokens.$dGreen250,
  "--focus-border": valueTokens.$dGreen500,

  // Greens
  "--green-100": valueTokens.$dGreen100,
  "--green-150": valueTokens.$dGreen150,
  "--green-200": valueTokens.$dGreen200,
  "--green-300": valueTokens.$dGreen300,
  "--green-400": valueTokens.$dGreen400,
  "--green-500": valueTokens.$dGreen500,

  // Amber
  "--amber-100": valueTokens.$dAmber100,
  "--amber-200": valueTokens.$dAmber200,
  "--amber-300": valueTokens.$dAmber300,
  "--amber-400": valueTokens.$dAmber400,
  "--amber-500": valueTokens.$dAmber500,

  // Indigo
  "--indigo-100": valueTokens.$dIndigo100,
  "--indigo-200": valueTokens.$dIndigo200,
  "--indigo-300": valueTokens.$dIndigo300,
  "--indigo-400": valueTokens.$dIndigo400,
  "--indigo-500": valueTokens.$dIndigo500,

  // Kivra Extra
  "--kvx-sand100": valueTokens.$dKvxSand100,
  "--kvx-sand200": valueTokens.$dKvxSand200,
  "--kvx-gradient01": valueTokens.$dKvxGradient01,

  // Box shadow
  "--shadow-raised": "none",
  "--shadow-floating": "none",
  "--shadow-hover-list": "none",
};
